import exp from "node:constants";


export const DPourData = {
    id: -1,
    name: "",
    position: -1,
    state: "",
    price: 0,
    unit: "",
    beverage_id: -1,
    cart_id: -1,
    full_capacity: 1600,
    new_full_capacity: -1,
    current_capacity: -1
}
